import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faX, faLocationDot, faEnvelope, faUser, faPhone, faMessage } from '@fortawesome/free-solid-svg-icons';
import {
  faComments,
} from '@fortawesome/free-regular-svg-icons';
import { 
  faWhatsapp, faTiktok, faTwitter, faInstagram,
  faLinkedin, faFacebook, faTwitch, faYoutube,
} from '@fortawesome/free-brands-svg-icons';
import { useHistory } from 'react-router-dom';
import { useApi } from '../../hooks/useApi';
import useThemes from '../../hooks/useThemes';

library.add(
  faWhatsapp, faTiktok, faTwitter, faInstagram,
  faLinkedin, faFacebook, faTwitch, faYoutube, faX, faLocationDot, faEnvelope, faUser, faPhone, faComments,
  faMessage,
  );

const Flotante = () => {
  const history = useHistory();
  const { contacto, getContacto } = useApi();
  const { data } = contacto;

  const { backgroundCuarto, colorPrincipal, colorSecundario } = useThemes();

  const [clicked, setClicked] = useState(false);

  useEffect(() => {
    getContacto();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container
      background={backgroundCuarto}
      colorprincipal={colorPrincipal}
      colorsecundario={colorSecundario}
    >
      {clicked && (
        <div className='info'>
          {
            data?.dataAllContact?.map((item) => (
              item.rutaOpcion.includes("http") ? 
              <a
                key={item.id}
                href={ item.rutaOpcion.includes("http") ? item.rutaOpcion : `mailto:${item.nombreOpcion}`}
                className='info-icon'
                target='_blank'
                rel='noreferrer'
                onClick={() => setClicked((prevState) => !prevState)}
              >
                <FontAwesomeIcon
                  icon={item.icono}
                  color={colorSecundario}
                  size='lg'
                />
                <p>{item.nombreOpcion}</p>
              </a>
              : item.rutaOpcion.includes('lineaatencion') ? (
                ''
              ) 
              :
              <>
                <div
                  key={item.id}
                  className='info-icon'
                  onClick={() => {
                    setClicked((prevState) => !prevState);
                    history.push(item.rutaOpcion);
                  }}
                >
                  <FontAwesomeIcon
                    icon={item.icono}
                    color={colorSecundario}
                    size='lg'
                  />
                  <p>{item.nombreOpcion}</p>
                </div>
              </>
            )

            )
          }
        </div>
      )}
      {clicked ? (
        <div
          className='button-x'
          onClick={() => setClicked((prevState) => !prevState)}
        >
          <FontAwesomeIcon icon={faX} color={colorPrincipal} size='2x' />
        </div>
      ) : (
        <div
          className='button'
          onClick={() => setClicked((prevState) => !prevState)}
        >
          <p>
            formas de <br /> contacto
          </p>
          <div className='icon-container'>
            <FontAwesomeIcon
              icon={faComments}
              color={backgroundCuarto}
              size='2x'
            />
          </div>
        </div>
      )}
    </Container>
  );
};

export default Flotante;

const Container = styled.div`
  position: fixed;
  bottom: 3%;
  right: 2%;
  z-index: 50;

  .info {
    transition: all ease 0.3s;
    animation-name: showdisplay;
    animation-duration: 0.3s;

    @keyframes showdisplay {
      0% {
        transform: translateY(100%);
        transform: scale(20%);
      }

      50% {
        transform: translateY(50%);
        transform: scale(50%);
      }

      100% {
        transform: translateY(0%);
        transform: scale(100%);
      }
    }
  }

  .info-icon {
    display: flex;
    align-items: center;
    border-radius: 3rem;
    overflow: hidden;
    margin-bottom: 1rem;
    padding: 0.8rem 1.5rem;
    cursor: pointer;
    border: 2px solid ${(props) => props.colorsecundario};
    background-color: ${(props) => props.background};

    &:hover {
      filter: brightness(1.1);
    }

    /* img {
      width: 3rem;
    } */

    p {
      font-weight: 700;
      margin: auto 1rem;
      color: ${(props) => props.colorsecundario};
    }
  }

  .button-x {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 6rem;
    height: 6rem;
    padding: 2rem;
    margin-left: auto;
    border-radius: 3rem;
    cursor: pointer;
    border: 2px solid ${(props) => props.colorsecundario};
    background-color: ${(props) => props.background};
    transition: all ease 0.3s;

    &:hover {
      filter: brightness(1.1);
      transform: scale(1.1);
    }
  }

  .button {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 17.4rem;
    height: 6rem;
    padding-left: 2rem;
    border-radius: 3rem;
    overflow: hidden;
    cursor: pointer;
    background-color: ${(props) => props.background};
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    transition: all ease 0.3s;

    &:hover {
      filter: brightness(1.1);
      transform: scale(1.1);
    }

    p {
      margin: auto 0;
      font-size: 12px;
      font-weight: 900;
      text-transform: uppercase;
      line-height: 1;
      text-align: right;
      color: ${(props) => props.colorprincipal};
    }

    .icon-container {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 6rem;
      height: 6rem;
      padding: 2rem;
      border-radius: 3rem;
      background-color: ${(props) => props.colorprincipal};
    }
  }

  @media (max-width: 1023px) {
    .button {
      width: 6rem;
      height: 6rem;
      padding-left: 0;
      transition: none;

      p {
        display: none;
      }
    }
  }
`;
